export function getAgendaPageConfig(structure) {
    const config = structure || {};
    return {
        ...Object.entries(config).reduce(
            (acc, [nodeName, nodeConfig]) => ({
                ...acc,
                // Remove the props object from every property and put the properties one level up
                [nodeName]: nodeConfig.props,
            }),
            {},
        ),
    };
}
